
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from '../controlador';
    import { Transporte } from '@/__env/lib/Expedicion/Transportes';
    import * as Pedidos from '@/__env/lib/Ventas/Pedidos';
    import { Pedido } from '@/__env/lib/Ventas/Pedidos';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import { Wait } from '@/__env/ext';

    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {

        @Prop()
        public Controlador: ControladorSeccion;
        @Prop()
        public Abrir: boolean;
        @Watch( 'Abrir' )
        onAbrir()
        {
            this.Abierto = true;
            this.Limite = null;
            this.Seleccionada = null;
        }

        public get Buscador() { return this.Controlador.Buscador; }
        public get Seleccionados() { return this.Controlador.Seleccionados; }
        public get Estado() { return this.Controlador.Buscador.Estado; }

        public Abierto: boolean = false;
        public Limite: number = null;
        public Seleccionada: string = '';
        public Opciones: { Id: string, Descripcion: string; }[] = [
            { Id: 'auto', Descripcion: 'Marca automática' },
            { Id: 'pendiente', Descripcion: 'Todo lo pendiente' },
            { Id: 'mercado-envios', Descripcion: 'Solo MercadoEnvios' },
            { Id: 'mercado-envios-flex', Descripcion: 'Solo MercadoEnvios Flex' },
            { Id: 'retira-cliente', Descripcion: 'Solo retira cliente' },

        ];

        public get Ok(): boolean
        {
            return this.Seleccionada && this.Seleccionada.length > 0;
        }

        public Cargando: boolean = false;
        async Descargar()
        {

            let pedidos = await Pedido.Marca( this.Seleccionada, this.Limite );

            if ( !pedidos.hasRows() )
            {
                Utiles.Notificaciones.Info( 'No se encontraron ventas' );
                return;
            }

            if ( ! await Utiles.Mensajes.SiNo( 'Crear hoja de piso', `¿Crear hoja de piso con ${pedidos.length} pedidos?` ) )
                return;

            this.Cargando = true;
            Utiles.GenerandoArchivo( true );
            let pdf = await Pedido.URLHojaDePiso( pedidos );
            if ( pdf )
            {
                for ( let p of this.Buscador.Items )
                {
                    if ( pedidos.findIndex( x => x.Id == p.Id ) != -1 )
                        p.Estado = Pedidos.Estados.Preparando;
                }
                await Wait( 100 );
                this.Controlador.RecargarEstadistica();
                window.open( pdf );
            } else
            {
                Utiles.Notificaciones.Error( `Error al generar la hoja de piso` );

            }
            Utiles.GenerandoArchivo( false);
            this.Cargando = false;
        }

        Cerrar()
        {
            this.Abierto = false;
        }

    }
